import React, { Component } from 'react';
import { connect } from 'react-redux';
import GenericExport from '../Components/GenericExport';
import { translate } from '../Services/translation';
import { load, exportData, setActiveExportType, setActiveExportFields, removeExportFields, addFieldData, eraseAllFieldData, removeFieldData, changeActiveFieldType, addDataSource, removeDataSource, storeUpdateCustomerData, toggleExportDone } from '../Actions/GenericExport.action';

class GenericExportContainer extends Component {
    constructor(props) {
        super(props);
        this.state = { ...props };
        this.clickHandler = this.clickHandler.bind(this);
        this.lastClickedNode = null;
    }

    componentDidMount() {
        // This method is automatically triggering when component is loaded
        this.props.load();
        document.addEventListener('mousedown', this.clickHandler);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.clickHandler);
        
    }

    componentWillUpdate({ pdfCustomerData } = props) {
        if (this.state.pdfCustomerData !== pdfCustomerData) {
            this.setState({ ...this.state, pdfCustomerData });
        }
    }

    clickHandler(event) {
        this.lastClickedNode = event.target;

        // If Export done text is visible. Hide it on click
        const { toggleExportDone } = this.props;
        if (toggleExportDone) {
            toggleExportDone();
        }
    }

    onExport(event) {
        const el = this.lastClickedNode;
        const form = el.form;
        //const data = new FormData(event.target);
        const exportType = form.elements['exportObjectTemplate'].value;
        const exportObjectTemplateEl = form.exportObjectTemplate;
        const exportObjectTemplateSelectedEl = exportObjectTemplateEl.options[exportObjectTemplateEl.selectedIndex];
        const method = exportObjectTemplateSelectedEl.dataset.method;
        const responseType = exportObjectTemplateSelectedEl.dataset.type;
        const exportObjectIndex = form.elements['exportObjectIndex'].value;

        if (exportType !== undefined && exportType.length > 0) {
            let confirmMessage = exportObjectTemplateSelectedEl.text + ':\n' + translate('common.genericexport.confirmexport');
            confirmMessage = confirmMessage.replace('[x]', exportType);
            var doExport = confirm(confirmMessage);
            const { exportData } = this.props;
            if (doExport && exportData) {
                exportData(exportType.toLowerCase(), method, responseType, exportObjectIndex);
            }
        }
        return false;
    }

    setActiveType(event) {
        const el = this.lastClickedNode;
        const form = el.form;
        const selectedEl = form.exportObjectType;
        let exportType = el.value;
        let exportIndex = 0;

        if (selectedEl) {
            exportType = selectedEl.value;
            exportIndex = selectedEl.selectedIndex - 1;
        }

        const { setActiveExportType } = this.props;

        if (setActiveExportType) {
            setActiveExportType(exportType, exportIndex);
        }
    }

    addFieldToCollection(event) {
        const el = this.lastClickedNode;
        const form = el.form;
        const fieldDataLeftEl = form.fieldDataLeft;
        const fieldDataLeftSelectedEl = fieldDataLeftEl.options[fieldDataLeftEl.selectedIndex];

        const fieldIdLeft = fieldDataLeftSelectedEl.dataset.id;
        const fieldDataLeft = form.elements['fieldDataLeft'].value;
        const exportFieldDescriptionLeft = fieldDataLeftSelectedEl.dataset.description ? fieldDataLeftSelectedEl.dataset.description : "";
        const isBaseProductLeft = fieldDataLeftSelectedEl.dataset.isbaseproduct === 'true' ? true : false;

        const fieldObjectTypeLeft = fieldDataLeftSelectedEl.dataset.type;
        const fieldDeliminatorEl = form.elements['fieldDeliminator'];
        const fieldDeliminator = fieldDeliminatorEl ? fieldDeliminatorEl.value : '';
        let fieldIdRight = '';

        const fieldDataRight = form.elements['fieldDataRight'] ? form.elements['fieldDataRight'].value : '';
        let fieldObjectTypeRight = '';
        const fieldHeading = form.elements['fieldHeading'] ? form.elements['fieldHeading'].value : '';
        const exportObjectIndex = form.elements['exportObjectIndex'].value;
        const imageWidth = form.elements['imageWidth'] ? form.elements['imageWidth'].value : '';
        const imageHeight = form.elements['imageHeight'] ? form.elements['imageHeight'].value : '';

        let isBaseProductRight = false;
        let exportFieldDescriptionRight = "";
        const fieldDataRightEl = form.fieldDataRight;
        if (fieldDataRightEl) {
            const fieldDataRightSelectedEl = fieldDataRightEl.options[fieldDataRightEl.selectedIndex];
            fieldIdRight = fieldDataRightSelectedEl.dataset.id;
            fieldObjectTypeRight = fieldDataRightSelectedEl.dataset.type;
            exportFieldDescriptionRight = fieldDataRightSelectedEl.dataset.description ? fieldDataRightSelectedEl.dataset.description : "";
            isBaseProductRight = fieldDataRightSelectedEl.dataset.isbaseproduct === 'true' ? true : false;
        }

        const { addFieldData } = this.props;
        if (addFieldData) {
            addFieldData(fieldIdLeft, fieldDataLeft, fieldObjectTypeLeft, fieldDeliminator, fieldIdRight, fieldDataRight, fieldObjectTypeRight, fieldHeading, imageWidth, imageHeight, isBaseProductLeft, isBaseProductRight, exportFieldDescriptionLeft, exportFieldDescriptionRight, exportObjectIndex);
            // Reset fields : fieldDataRight + fieldDeliminator
            if (fieldDataRightEl) {
                fieldDataRightEl.selectedIndex = 0;
            }
            if (fieldDataRightEl) {
                fieldDeliminatorEl.value = "";
            }
            
            

        }
        return false;
    }

    clearAllFieldsInCollection(event) {
        var doClearFields = confirm(translate('common.genericexport.confirmclear'));
        const el = this.lastClickedNode;
        const objectIndex = el.dataset.objectindex;
        const { eraseAllFieldData } = this.props;
        if (doClearFields && eraseAllFieldData) {
            eraseAllFieldData(objectIndex);
        }
    }

    removeThisFieldInCollection(event) {
        const el = this.lastClickedNode;
        const fieldIndex = el.dataset.fieldindex;
        const objectIndex = el.dataset.objectindex;

        const { removeFieldData } = this.props;
        if (removeFieldData) {
            removeFieldData(objectIndex, fieldIndex);
        }
    }

    removeSelectedDataSource(event) {
        const el = this.lastClickedNode;
        const sourceIndex = el.dataset.sourceindex;
        const { removeDataSource } = this.props;
        if (removeDataSource) {
            removeDataSource(sourceIndex);
        }
    }

    setSelectedFieldType(event) {
        const clickedEl = this.lastClickedNode;
        const form = clickedEl.form;
        const el = form.fieldDataLeft;
        const objectIndex = el.dataset.objectindex;

        const fieldEl = el.options[el.selectedIndex];
        var type = '';
        if (fieldEl != null) {
            type = fieldEl.dataset.type;
        }
        const { changeActiveFieldType } = this.props;
        if (changeActiveFieldType) {
            changeActiveFieldType(objectIndex, type);
        }
    }

    closeGe() {
        var doClose = confirm(translate('common.genericexport.confirmclose'));
        const genericEl = document.getElementById("genericExport");
        if (doClose && genericEl) {
            genericEl.classList.add('generic-export__container--hide');
        }
    }

    render() {
        // Render the component
        return <GenericExport {...{ ...this.props, onExport: () => this.onExport(event), addDataSource: () => this.addSelectedDataSource(event), setActiveType: () => this.setActiveType(event), addFieldToCollection: () => this.addFieldToCollection(event), clearAllFieldsInCollection: () => this.clearAllFieldsInCollection(event), removeSelectedDataSource: () => this.removeSelectedDataSource(event), removeThisFieldInCollection: () => this.removeThisFieldInCollection(event), setSelectedFieldType: () => this.setSelectedFieldType(event), closeGe: () => this.closeGe(event) }} />
    }

    addSelectedDataSource(event) {
        const el = this.lastClickedNode;
        const form = el.form;
        const selectedEl = form.dataSource;
        if (selectedEl.selectedIndex>0){
            var item = this.props.dataSources[selectedEl.selectedIndex];
            const { addDataSource } = this.props;
            if (addDataSource && item.type !== 'Spacer'){
                addDataSource(item);
            }
        }
    }
}

const mapStateToProps = state => {
    const { genericExport } = state;
    return {
        ...genericExport
    }
}

const mapDispatchToProps = dispatch => {
    return {
        load: () => dispatch(load()),
        toggleExportDone: () => dispatch(toggleExportDone()),
        exportData: (exportType, method, responseType, exportObjectIndex) => dispatch(exportData(exportType, method, responseType, exportObjectIndex)),
        addFieldData: (fieldIdLeft, fieldDataLeft, fieldObjectTypeLeft, fieldDeliminator, fieldIdRight, fieldDataRight, fieldObjectTypeRight, fieldHeading, imageWidth, imageHeight, isBaseProductLeft, isBaseProductRight, exportFieldDescriptionLeft, exportFieldDescriptionRight, exportObjectIndex) => dispatch(addFieldData(fieldIdLeft, fieldDataLeft, fieldObjectTypeLeft, fieldDeliminator, fieldIdRight, fieldDataRight, fieldObjectTypeRight, fieldHeading, imageWidth, imageHeight, isBaseProductLeft, isBaseProductRight, exportFieldDescriptionLeft, exportFieldDescriptionRight, exportObjectIndex)),
        eraseAllFieldData: (exportObjectIndex) => dispatch(eraseAllFieldData(exportObjectIndex)),
        removeFieldData: (exportObjectIndex, fieldIndex) => dispatch(removeFieldData(exportObjectIndex, fieldIndex)),
        setActiveExportType: (exportTypeName, activeObjectIndex) => dispatch(setActiveExportType(exportTypeName, activeObjectIndex)),
        setActiveExportFields: (customerExportFieldName, activeObjectIndex) => dispatch(setActiveExportFields(customerExportFieldName, activeObjectIndex)),
        removeExportFields: (customerExportFieldName, activeObjectIndex) => dispatch(removeExportFields(customerExportFieldName, activeObjectIndex)),
        changeActiveFieldType: (objectIndex, type) => dispatch(changeActiveFieldType(objectIndex, type)),
        addDataSource: (selectedDataSource) => dispatch(addDataSource(selectedDataSource)),
        removeDataSource: (selectedDataSourceIndex) => dispatch(removeDataSource(selectedDataSourceIndex)),
        storeUpdateCustomerData: (objectName, objectValue) => dispatch(storeUpdateCustomerData(objectName, objectValue)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GenericExportContainer);